import { render, staticRenderFns } from "./UpdateReportByUpdateType.vue?vue&type=template&id=c36a6a06&"
import script from "./UpdateReportByUpdateType.vue?vue&type=script&lang=js&"
export * from "./UpdateReportByUpdateType.vue?vue&type=script&lang=js&"
import style0 from "./UpdateReportByUpdateType.vue?vue&type=style&index=0&id=c36a6a06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
